import { render, staticRenderFns } from "./PageShell.vue?vue&type=template&id=11ef39e8&scoped=true"
import script from "./PageShell.vue?vue&type=script&lang=js"
export * from "./PageShell.vue?vue&type=script&lang=js"
import style0 from "./PageShell.vue?vue&type=style&index=0&id=11ef39e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ef39e8",
  null
  
)

export default component.exports